/** charges group: charge lines and adjustments (docs/03 "Vocabulary"). A WP adds to its own group and to docs/03 in the same commit. */
export const chargesPermissions = ['charge:read', 'charge:write', 'charge:confirm', 'charge:adjust'] as const;

export type ChargesPermission = (typeof chargesPermissions)[number];
